import React from 'react';

import { IconEthereumColor, IconEthereumLight } from '@pkg/assets/icons/currency';
import { NumberCounter, type NumberCounterProps } from '@pkg/components';
import { FloorGameCrypto } from '@pkg/floorGame';

import { Conversion, Label, StyledCurrencyDisplay, Suffix, Symbol } from './styles';

// We might want to do the `localConversion` internally,
// and simply make `localConversion` a `boolean` to show/hide.
export interface CurrencyDisplayProps {
    currency?: FloorGameCrypto;
    price?: NumberCounterProps['value'];
    label?: string;
    localConversion?: string;
    symbol?: boolean;
    // TODO: It might be better to control the size
    // using a `factor` (relative scaling).
    compact?: NumberCounterProps['compact'];
}

export function CurrencyDisplay({
    currency,
    price = 0,
    label,
    localConversion,
    symbol = false,
    compact = false,
}: CurrencyDisplayProps) {
    const currencySymbol = symbol ? getCryptoSymbol(currency) : null;
    const symbolMarkup = currencySymbol ? <Symbol>{currencySymbol}</Symbol> : null;

    const labelMarkup = label ? <Label>{label}</Label> : null;
    const conversionMarkup = localConversion ? <Conversion>{localConversion}</Conversion> : null;

    const suffixMarkup =
        labelMarkup || conversionMarkup ? (
            <Suffix>
                {labelMarkup}
                {conversionMarkup}
            </Suffix>
        ) : null;

    return (
        <StyledCurrencyDisplay $compact={compact}>
            {symbolMarkup}
            <NumberCounter value={price} compact={compact} />
            {suffixMarkup}
        </StyledCurrencyDisplay>
    );
}

// TODO: We should turn this into a useCryptoSymbol() hook.
// We can then pass an argument for `light / dark / color` icons.
export function getCryptoSymbol(currency?: FloorGameCrypto, light = false) {
    if (currency === FloorGameCrypto.Ethereum) {
        return light ? <IconEthereumLight /> : <IconEthereumColor />;
    }

    return null;
}
